import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const socials = [{
  name: "Instagram",
  url: "#"
}, {
  name: "Facebook",
  url: "#"
}, {
  name: "LinkedIn",
  url: "#"
}];
const legalLinks = [{
  name: "Privacy Policy",
  url: "/ContactPage"
}, {
  name: "Terms of Service",
  url: "/ContactPage"
}];
export default function Footer() {
  return <section data-section-id="175327" id="footer" className="bg-background text-foreground pt-24 pb-8">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20">
          {}
          <div className="flex flex-col items-start">
            <img src="https://immune-albacore-dev.10web.cloud/wp-content/uploads/2026/03/BODYWERKS-LOGO-COLOR-NO-BGR-scaled.png" alt="Bodywerks Logo" className="object-contain !h-[258px] !w-[400px]" />
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-serif text-primary text-xl mb-6 tracking-wide">
              Limassol Clinic
            </h3>
            <address className="not-italic text-muted-foreground text-sm space-y-2">
              <p className="!text-[hsl(28,91%,54%)]">Foloune House Gladstonos 120 Unit 5 Limassol 3032</p>
              <p className="!text-[hsl(28,91%,54%)]">+357 25 954 014&nbsp;<br />Mon, Wed, Fri  4PM-8PM, <br />Tues, Thurs, Sat 9:30AM-12:30PM</p>
              <div className="pt-4">
                <Link to="/ContactPage" className="text-foreground hover:text-accent transition-colors inline-block border-b border-accent/30 pb-0.5">
                  View on Map
                </Link>
              </div>
            </address>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-serif text-primary text-xl mb-6 tracking-wide">
              Nicosia Clinic
            </h3>
            <div className="text-muted-foreground text-sm space-y-2">
              <p className="!text-[hsl(28,91%,54%)]">Alexiou Building, Ifigenias 62-3rd Floor, Nicosia 2003
              <div>Mobile and Message: 99 08 56 96<br />&nbsp;| Mon-Fri: 8AM-7PM</div></p>
            </div>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-serif text-primary text-xl mb-6 tracking-wide">
              Connect
            </h3>
            <ul className="text-muted-foreground text-sm space-y-3">
              {socials.map((social, i) => <li key={social.name} data-index={i}>
                  <Link to={social.url} className="hover:text-accent transition-colors">
                    {social.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <Separator className="bg-accent/20 mb-6" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] text-muted-foreground uppercase tracking-widest">
          <p>
            &copy; {new Date().getFullYear()} Bodywerks. Your body. Our expertise. Cyprus.
          </p>
          <ul className="flex gap-6">
            {legalLinks.map((link, i) => <li key={link.name} data-index={i}>
                <Link to={link.url} className="hover:text-accent transition-colors">
                  {link.name}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}